import { FINANCE_HELP_ENTRIES } from './financeGuides.ts';
import { GENERAL_HELP_ENTRIES } from './generalGuides.ts';
import { OPERATIONS_HELP_ENTRIES } from './operationsGuides.ts';
import { PAGE_HELP_FLOWS } from './flows.ts';
import type { PageHelpGuide } from './types.js';

export const PAGE_HELP_ENTRIES = [
  ...GENERAL_HELP_ENTRIES,
  ...FINANCE_HELP_ENTRIES,
  ...OPERATIONS_HELP_ENTRIES,
].map((entry) => {
  const flows = PAGE_HELP_FLOWS[entry.guide.id];
  return flows?.length ? { ...entry, guide: { ...entry.guide, flows } } : entry;
});

/** Exact segment matching prevents a detail URL from silently receiving a hub guide. */
export function matchesHelpPath(template: string, pathname: string): boolean {
  const expected = template.split('/').filter(Boolean);
  const actual = pathname.split('/').filter(Boolean);
  return (
    expected.length === actual.length &&
    expected.every((part, i) => (part.startsWith(':') ? Boolean(actual[i]) : part === actual[i]))
  );
}

export function resolvePageHelp(pathname: string, tenantSlug: string): PageHelpGuide | null {
  const clean = pathname.split(/[?#]/, 1)[0]?.replace(/\/+$/, '') ?? '';
  const base = `/t/${tenantSlug}`;
  if (!tenantSlug || (clean !== base && !clean.startsWith(`${base}/`))) return null;
  const relative = clean.slice(base.length) || '/';
  return (
    PAGE_HELP_ENTRIES.find((entry) => entry.paths.some((path) => matchesHelpPath(path, relative)))
      ?.guide ?? null
  );
}
